<template>
    <div class="supplyRatioQueryLayout">
        <m-assembly-table :formData="formData"
                          :columns="tableColumns"
                          :data="tableData"
                          :tableButtons="tableButtons"
                          :currentPage="settings.currentPage"
                          :pageSize="settings.pageSize"
                          :settings="settings"
                          :loading="loading"
                          :total="settings.total"
                          @onSubmit="onSubmit"
                          @onPageSizeChange="onPageSizeChange"
                          @onCurrentPageChange="onPageChange"
                          ref="searchForm">
            <span slot="tips" class="tips">{{this.$t('supplyRatioQueryTable.remarkTxt')}}</span>
        </m-assembly-table>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
import { exportExcel } from '@/utils/tool';
export default {
    name: 'SupplyRatioQuery',
    components: {mAssemblyTable},
    computed: {
		/* 是否海外系统 */
        isInt() {
            return !this.$route.query.lang;
        },
    },
    data() {
        return {
            currLang: this.$i18n.locale,
            buVal: '',
            orgVal: '',
            orgBuss: [],
            orgResult: [],
            orgObj: { // 组织必填
                placeholder: '', // 请选择库存组织,
                title: this.$t('supplyRatioQueryTable.organization'), // 库存组织,
                value: '',
                field: 'organizationCode',
                validators: {
                    required: {
                        required: false,
                        message: this.$t('supplyRatioQueryTable.orgRequired')
                    }
                },
                layout: {
                    span: 8,
                    offset: 0,
                    row: 1
                },
                methods: {
                    change: () => {
                        this.orgVal = this.formData.items[1].value;
                    }
                },
                filterable: true,
                options: {
                    clearable: true,
                    values: []
                },
                type: 'select',
                style: 'width: 100%',
                labelWidth: 98
            },
            loginType: '',
            supplierInfo: {},
            settings: {
                needPager: true,
                showElevator: false,
                showSizer: true,
                pageSizeOpts: [10, 30, 50, 80],
                needTable: true,
                needSearch: true,
                needValidation: true,
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            formData: {
                row: 4,
                items: [
                    {
                        placeholder: '', // 请选择事业部,
                        title: this.$t('supplyRatioQueryTable.businessUnit'), // 事业部
                        value: '',
                        field: 'buId',
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {
                            change: () => {
                                this.buVal = this.formData.items[0].value;
                            }
                        },
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        style: 'width: 100%',
                        labelWidth: 98
                    },
                    {
                        placeholder: '', // 请选择比例类型,
                        title: this.$t('supplyRatioQueryTable.ratioType'), // 比例类型,
                        value: '',
                        field: 'queryTypes',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {},
                        options: {
                            clearable: true,
                            values: []
                        },
                        type: 'select',
                        style: 'width: 100%',
                        labelWidth: 98
                    },
                    {
                        placeholder: '', // 请输入采购分类
                        title: this.$t('supplyRatioQueryTable.category'), // 采购分类
                        value: '',
                        field: 'categoryName',
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        style: 'width: 100%',
                        labelWidth: 98
                    },
                    {
                        placeholder: '',
                        title: this.$t('supplyRatioQueryTable.ratioMonth'), // 比例月份,
                        isDouble: true,
                        value: '',
                        field: 'startMonth',
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('supplyRatioQueryTable.errorNullStartMonth')
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        methods: {},
                        options: {
                            clearable: true,
                            format: 'yyyy-MM',
                            type: 'month'
                        },
                        type: 'datePicker',
                        style: 'width: 100%',
                        labelWidth: 98
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'endMonth',
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('supplyRatioQueryTable.errorNullEndMonth')
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        methods: {},
                        options: {
                            clearable: true,
                            format: 'yyyy-MM',
                            type: 'month'
                        },
                        type: 'datePicker',
                        placeholder: '',
                        style: 'width: 100%',
                        labelWidth: 98
                    },
                    {
                        placeholder: '', // 请输入物料编码
                        title: this.$t('supplyRatioQueryTable.itemCode'), // 物料编码
                        value: '',
                        field: 'itemCode',
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        style: 'width: 100%',
                        labelWidth: 98
                    }
                ],
                buttons: {
                    showSubmit: true,
                    showReset: true,
                    showSearch: true,
                    layout: {
                        span: 24,
                        push: 8
                    }
                }
            },
            tableColumns: {
                columns: [
                    {
                        title: this.$t('supplyRatioQueryTable.ratioMonth'), // 比例月份,
                        key: 'month',
                        align: 'center',
                        tooltip: true,
                        minWidth: 90
                    },
                    {
                        title: this.$t('supplyRatioQueryTable.ratioType'), // 比例类型
                        key: 'queryTypesName',
                        sortable: true,
                        align: 'center',
                        minWidth: 95
                        // render: (h, params) => {
                        //     return this.getLabelByDict(h, params, 'queryTypes', 'queryTypes');
                        // }
                    },
                    {
                        title: this.$t('supplyRatioQueryTable.businessUnit'), // 事业部
                        key: 'buName',
                        sortable: true,
                        align: 'left',
                        minWidth: 170,
                        render: (h, params) => {
                            return h('Tooltip', {
                            props: {
                                content: params.row.buName,
                                placement: 'top'
                            },
                            class: 'm-tooltip-overflow'
                            }, params.row.buName);
                        }
                    },
                    {
                        title: this.$t('supplyRatioQueryTable.organization'), // 库存组织
                        key: 'organizationName',
                        sortable: true,
                        align: 'left',
                        minWidth: 190,
                        render: (h, params) => {
                            return h('Tooltip', {
                            props: {
                                content: params.row.organizationName,
                                placement: 'top'
                            },
                            class: 'm-tooltip-overflow'
                            }, params.row.organizationName);
                        }
                    },
                    {
                        title: this.$t('supplyRatioQueryTable.category'), // 采购分类
                        key: 'categoryName',
                        align: 'left',
                        minWidth: 140,
                        render: (h, params) => {
                            return h('Tooltip', {
                            props: {
                                content: params.row.categoryName,
                                placement: 'top'
                            },
                            class: 'm-tooltip-overflow'
                            }, params.row.categoryName);
                        }
                    },
                    {
                        title: this.$t('supplyRatioQueryTable.matchPerson'), // 配套主管
                        key: 'matchPerson',
                        align: 'left',
                        tooltip: true,
                        minWidth: 110
                    },
                    {
                        title: this.$t('supplyRatioQueryTable.itemCode'), // 物料编码
                        key: 'itemCode',
                        align: 'left',
                        tooltip: true,
                        minWidth: 120
                    },
                    {
                        title: this.$t('supplyRatioQueryTable.description'), // 物料描述
                        key: 'itemName',
                        align: 'left',
                        minWidth: 200,
                        render: (h, params) => {
                            return h('Tooltip', {
                            props: {
                                content: params.row.itemName,
                                placement: 'top'
                            },
                            class: 'm-tooltip-overflow'
                            }, params.row.itemName);
                        }
                    },
                    {
                        title: this.$t('supplyRatioQueryTable.perfSort'), // 绩效排序
                        key: 'perfSort',
                        align: 'center',
                        tooltip: true,
                        minWidth: 90
                    },
                    {
                        title: this.$t('supplyRatioQueryTable.prevScale'), // 上月比例%
                        key: 'prevScale',
                        align: 'center',
                        tooltip: true,
                        minWidth: 80
                    },
                    {
                        title: this.$t('supplyRatioQueryTable.confirmScale'), // 制定比例%
                        key: 'confirmScale',
                        align: 'center',
                        tooltip: true,
                        minWidth: 60
                    },
                    {
                        title: this.$t('supplyRatioQueryTable.adjRatio'), // '调整比例%',
                        key: 'adjScale',
                        align: 'center',
                        tooltip: true,
                        minWidth: 60
                    },
                    {
                        title: this.$t('supplyRatioQueryTable.adjtype'), // '调整类型',
                        key: 'adjTypeName',
                        align: 'left',
                        tooltip: true,
                        minWidth: 90
                        // render: (h, params) => {
                        //     return this.getLabelByDict(h, params, 'adjType', 'adjType');
                        // }
                    },
                    {
                        title: this.$t('supplyRatioQueryTable.executeAdjust'), // 实际执行比例
                        key: 'executScale',
                        align: 'center',
                        minWidth: 60
                    }
                ]
            },
            tableData: [],
            tableButtons: {
                systemButtons: [],
                customButtons: [
                    {
                        name: '',
                        label: this.$t('common.export'), // 导出
                        type: 'primary',
                        loading: false,
                        click: (button) => {
                            this.exportOut(button);
                        }
                    }
                ]
            },
            dict: {
                status: [],
                orgCode: [],
                queryTypes: [],
                yesNo: [],
                vendorQaStatus: [],
                adjType: []
            },
            loading: false
        };
    },
    watch: {
        orgBuss: function () {
            this.formData.items.map((item) => {
                if (item.field === 'buId') {
                    item.options.values = this.orgBuss;
                }
            });
        },
        'buVal': function (newVal) {
            let orgObj2 = { // 组织非必填
                placeholder: '', // 请选择库存组织,
                title: this.$t('supplyRatioQueryTable.organization'), // 库存组织,
                value: '',
                field: 'organizationCode',
                validators: {
                    required: {
                        required: false,
                        message: this.$t('supplyRatioQueryTable.orgRequired')
                    }
                },
                layout: {
                    span: 8,
                    offset: 0,
                    row: 1
                },
                methods: {
                    change: () => {
                        this.orgVal = this.formData.items[1].value;
                    }
                },
                filterable: true,
                options: {
                    clearable: true,
                    values: []
                },
                type: 'select',
                style: 'width: 100%',
                labelWidth: 98
            };
            if (!this.buVal) { // 事业部为空的时候，库存组织可以选择全部组织
                this.formData.items.map((item) => {
                    if (item.field === 'organizationCode') {
                    item.options.values = this.orgResult;
                    }
                });
            }
            if (newVal) {
                this.formData.items.splice(1, 1, orgObj2); // 组织非必填

                let selectOrg = [];
                this.orgResult.forEach((item) => {
                    if (item.bussOrg === this.buVal) {
                    selectOrg.push(item);
                    }
                });
                // console.log('selectOrg::', selectOrg);
                this.formData.items.map((item) => {
                    if (item.field === 'organizationCode') {
                    item.options.values = selectOrg; // 级联显示当前事业部下的组织
                    }
                });
            } else {
                this.formData.items.splice(1, 1, this.orgObj); // 组织必填
                this.formData.items.map((item) => {
                    if (item.field === 'organizationCode') {
                    item.options.values = this.orgResult; // 显示全部组织
                    item.value = this.orgVal;
                    }
                });
            }
        },
        'orgVal': function (newVal) {
            if (newVal) {
                let _bussOrg = '';
                this.orgResult.forEach((item) => {
                    if (item.value === this.orgVal) {
                    _bussOrg = item.bussOrg;
                    }
                });
                let buVal = '';
                this.formData.items.forEach((item) => {
                    if (item.field === 'buId') {
                    buVal = item.value;
                    }
                });
                if (_bussOrg !== buVal) {
                    this.formData.items[0].value = _bussOrg; // 事业部需要与当前选择组织级联
                }

                if (!this.$refs.searchForm.$refs.queryForm.validateForm()) {
                    return false;
                }
            }
        },
    },
    methods: {
        /** 获取事业部 **/
        getBussOrg() {
            axios.get(this.isInt ? '/gscint/vendor/getOverSeaBuList?SITE=Y&ASL=N' : '/gscint/vendor/getAllBuList').then(res => {
                let { success, datas } = res.data.data;
                if (success) {
                    (datas || []).forEach(item => {
                        this.orgBuss.push({
                            label: item.buName,
                            value: item.buCode,
                            organizationId: item.organizationId
                        });
                    });
                }
            }).catch(() => (
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1')
                })
            ));
        },
        /** 获取组织 **/
        getOrganizationName: function () {
            axios.get('/gscint/vendor/getAllInvList?SITE=Y&ASL=N', {}).then(res => {
                let { datas, success, msg } = res.data.data;
                if (success) {
                    let arry = datas || [];
                    arry.forEach(each => {
                        this.orgResult.push({
                            label: each.organizationName,
                            value: each.organizationCode,
                            bussOrg: each.buId
                        });
                    });
                    this.formData.items.map((item) => {
                        if (item.field === 'organizationCode') {
                            item.options.values = this.orgResult;
                        }
                    });
                } else {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: msg
                    });
                }
            });
        },
        /** 获取字典Label**/
        getLabelByDict(h, params, dictName, colName) {
            let dict = this.dict[dictName].find((item) => {
                return item.value === params.row[colName];
            });
            if (dict) {
                return h('span', dict.label);
            } else {
                return h('span', '');
            }
        },
        getOrgByAxios(dictName, callBack) {
            axios.get('/srmquo/ratioHomemade/getInvList', {}).then(res => {
                if (res.success === true) {
                    this.dict[dictName] = [];
                    res.data.data.forEach(each => {
                        this.dict[dictName].push({
                            label: each.orgName.trim(),
                            value: each.orgCode
                        });
                    });

                    callBack && callBack();
                } else {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('common.error1') // res.msg
                    });
                }
            }).catch(err => {
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1'),
                    error: err.stack.toString()
                });
            });
        },

        onPageChange: function (currentPage, pageSize, condition) {
            this.settings.currentPage = currentPage;
            this.onSearch();
        },
        /** 页码改变时触发**/
        onPageSizeChange: function (currentPage, pageSize, condition) {
            this.settings.currentPage = 1;
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        /** 查询**/
        onSubmit: function(current, pageSize, condition) {
            this.condition = condition;
            this.settings.currentPage = 1;
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        /** 搜索 */
        onSearch: function () {
            let params = this.condition;
            params.language = this.currLang;
            params.vendorCode = this.supplierInfo.vendorCode;
            params.pageIndex = this.settings.currentPage;
            params.pageSize = this.settings.pageSize;
            params.buOrganizationCode = this.buVal;
            params.organizationCode = this.orgVal;
            params.startMonth = params.startMonth ? params.startMonth.split('-').join('') : '';
            params.endMonth = params.endMonth ? params.endMonth.split('-').join('') : '';
            let url = '/srmquo/gsc/supplyRatio/querySupplyRatio';
            this.loading = true;
            this.tableData = [];
            axios.post(url, params).then(res => {
                try {
                    this.loading = false;
                    const { success, data, msg: content } = res.data;
                    if (success) {
                        this.settings.total = data.total;
                        this.tableData = data.list;
                        this.tableData.map((item, index) => {
                            item.adjustCreationDate = item.adjustCreationDate ? this.formatDate1(item.adjustCreationDate) : '';
                            item.creationDate = item.creationDate ? this.formatDate1(item.creationDate) : '';
                        });
                    } else {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content,
                        });
                    }
                } catch (err) {
                    console.log('err:', err);
                }
            }).catch(() => {
                this.loading = false;
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1')
                });
            });
        },
        /** 日期格式化 */
        formatDate1(val) {
            return /\d{4}-\d{1,2}-\d{1,2}/g.exec(val)[0];
        },
        /** 采购分类 */
        itemSearch1(query, type) {
            let params = {
                pageSize: 50,
                pageNum: 1,
                [type]: query.trim()
            };
            let url = '/srmquo/ratioException/queryCategoryName';
            this.loading3 = true;
            axios.get(url, {params}).then(res => {
                this.loading3 = false;
                let resp = res.data;
                if (resp.status === 0) {
                    resp.data.list.map((item) => {
                        item.value = item.cateCode;
                        item.label = item.cateName;
                    });
                    this.formData.items[3].options.values = resp.data.list;
                } else {
                    this.$Modal.info({
                        title: this.$t('common.warn'),
                        content: res.data.msg
                    });
                }
            }).catch(() => {
                this.loading3 = false;
                this.$Modal.info({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1')
                });
            });
        },
        /** 导出 */
        exportOut: function (button) {
            if (!this.$refs.searchForm.$refs.queryForm.validateForm()) { // 验证所有
                return false;
            }
            let params = {};
            params.language = this.currLang;
            params.vendorCode = this.supplierInfo.vendorCode;
            this.formData.items.forEach((item) => { params[item.field] = item.value; });
            params.startMonth = params.startMonth ? moment(params.startMonth).format('YYYY-MM').split('-').join('') : '';
            params.endMonth = params.endMonth ? moment(params.endMonth).format('YYYY-MM').split('-').join('') : '';

            params.buOrganizationCode = this.buVal;
            params.organizationCode = this.orgVal;
            // this.tableButtons.customButtons[0].loading = true;
            // var a = document.createElement('a');
            // a.href = '/gscint/supplyRatio/exportSupplyRatio?paraJson=' + encodeURI(JSON.stringify(params));
            // a.style.display = 'none';
            // document.body.appendChild(a);
            // a.click();
            // a.remove();
            // setTimeout(() => {
            //     this.tableButtons.customButtons[0].loading = false;
            // }, 5000);
            button.loading = true;
            exportExcel('/srmquo/gsc/supplyRatio/exportSupplyRatio', {
                ...params,
            }, `供货比例${moment().format('YYYY-MM-DD')}.xls`, this)
                .finally(() => {
                    button.loading = false;
                });
        },
        /** 字典查询**/
        getDictByCode(code, dictName, callBack) {
            axios.get('/srmquo/gsc/supplyRatio/queryDict', {
                params: {
                    dictCode: code,
                    language: this.currLang
                }
            }).then(res => {
                const { success, data, msg: content } = res.data;
                if (success) {
                    this.dict[dictName] = [];
                    data.forEach(each => {
                        this.dict[dictName].push({
                            label: each.ENTRY_NAME,
                            value: each.ENTRY_CODE
                        });
                    });
                    callBack && callBack();
                } else {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content,
                    });
                }
            }).catch(err => {
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1'),
                    error: err.stack.toString()
                });
            });
        },
        /** 获取字典**/
        getDict() {
            this.formData.items.splice(1, 0, this.orgObj);
            this.getBussOrg();
            this.getOrganizationName();
            this.getDictByCode('CUX_QUERY_TYPES', 'queryTypes', () => {
                this.formData.items[2].options.values = this.dict.queryTypes;
            });
            this.getDictByCode('CUX_DRL_ADJUST_TYPE', 'adjType', () => {}); // 调整类型
        }
    },
    mounted() {
        this.supplierInfo = JSON.parse(localStorage.getItem('supplierInfo'));
        this.getDict();
    }
};
</script>

<style lang='less'>
.supplyRatioQueryLayout{
    .tips {
        color:red;
        margin-left:20px;
        position:relative;
    }
}
</style>